import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { ISupplierDocument } from '~/types/document/models'

export const {
  getDocumentListData: getSupplierDocumentListData,
  getDocumentDataById: getSupplierDocumentDataById,
  getDocumentListDataByParentId: getSupplierDocumentListDataBySupplierId,
} = makeDocumentMockData<ISupplierDocument>({
  entityName: 'supplier',
  storageKeyPrefix: 'supplier',
})
